import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { flashMessage } from "../../../utils/flash";
import permissionService from "./permissionService";

const initialState = {
  all_permissions: [],
  isLoading: false,
  isSuccess: false,
  assignSuccess: false,
  isError: false,
  message: "",
  permission_info: {},
};

export const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    resetPermission: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.assignSuccess = false;
      state.isLoading = false;
      state.message = "";
    },
    resetPermissionStatus: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Create Permission
      .addCase(createPermission.pending, (state) => {
        state.isLoading = true;
        flashMessage("info", "Permission is creating...");
      })
      .addCase(createPermission.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.permission) {
          state.isError = false;
          state.isSuccess = true;
          flashMessage("success", action.payload.message);
        } else if (action.payload.errors) {
          state.isError = true;
          state.message = action.payload.error;
          flashMessage("error", "permission name is required");
        }
      })
      .addCase(createPermission.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        if (action.payload.errors) {
          state.isError = true;
          state.message = action.payload.error;
          flashMessage("error", action.payload.errors);
        }
      })
      // assign Permission
      .addCase(assignPermissions.pending, (state) => {
        state.isLoading = true;
        flashMessage("info", "Permission is assignining...");
      })
      .addCase(assignPermissions.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.permission) {
          state.isError = false;
          state.assignSuccess = true;
          flashMessage("success", action.payload.message);
        } else if (action.payload.errors) {
          state.isError = true;
          state.message = action.payload.error;
          flashMessage("error", action.payload.errors);
        }
      })
      .addCase(assignPermissions.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        if (action.payload.errors) {
          state.isError = true;
          state.message = action.payload.error;
          flashMessage("error", action.payload.errors);
        }
      })
      // Get Permission
      .addCase(getPermissions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPermissions.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          state.all_permissions = action.payload.data;
        } else if (action.payload.errors) {
          state.isError = true;
          state.message = action.payload.error;
          flashMessage("error", action.payload.error);
        }
      })
      .addCase(getPermissions.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        if (action.payload.errors) {
          state.isError = true;
          state.message = action.payload.error;
          flashMessage("error", action.payload.errors);
        }
      });
  },
});

// Create permission
export const createPermission = createAsyncThunk(
  "/permission/create",
  async (permissionData, thunkAPI) => {
    try {
      return await permissionService.createPermission(permissionData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Get permission
export const getPermissions = createAsyncThunk(
  "/permission/get",
  async (requestData, thunkAPI) => {
    try {
      return await permissionService.getPermissions(requestData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Assign permission
export const assignPermissions = createAsyncThunk(
  "/permission/assign",
  async (permissionData, thunkAPI) => {
    try {
      return await permissionService.assignPermissions(permissionData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const { resetPermission, resetPermissionStatus } =
  permissionSlice.actions;
export default permissionSlice.reducer;
